var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineVertic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33301C6.89543 1.33301 6 2.22844 6 3.33301C6 4.20382 6.55654 4.94465 7.33333 5.2192V10.7801C6.55654 11.0547 6 11.7955 6 12.6663C6 13.7709 6.89543 14.6663 8 14.6663C9.10457 14.6663 10 13.7709 10 12.6663C10 11.7955 9.44346 11.0547 8.66667 10.7801V5.2192C9.44346 4.94465 10 4.20382 10 3.33301C10 2.22844 9.10457 1.33301 8 1.33301ZM7.33333 3.33301C7.33333 2.96482 7.63181 2.66634 8 2.66634C8.36819 2.66634 8.66667 2.96482 8.66667 3.33301C8.66667 3.7012 8.36819 3.99967 8 3.99967C7.63181 3.99967 7.33333 3.7012 7.33333 3.33301ZM8 11.9997C7.63181 11.9997 7.33333 12.2982 7.33333 12.6663C7.33333 13.0345 7.63181 13.333 8 13.333C8.36819 13.333 8.66667 13.0345 8.66667 12.6663C8.66667 12.2982 8.36819 11.9997 8 11.9997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineVertic);
export default __webpack_public_path__ + "static/media/line-vertic.9c0cc7abbe31239ced48d4d7aae8011a.svg";
export { ForwardRef as ReactComponent };